<template>
  <div>
    <div style="margin-top: 5px" id="target" v-if="isValidUser">
      <div class="form-row">
        <h3>Accounting Closed Invoices</h3>
      </div>
      <ejs-grid
        :dataSource="accountingClosedInvoices"
        ref="refAccountingClosedInvoicesGrid"
        :created="created"
        :allowSorting="true"
        :allowPaging="true"
        :pageSettings="pageSettings"
        :toolbar="toolbarOptions"
        :toolbarClick="toolbarClick"
        :commandClick="cmdClosedInvoiceClick"
        :allowTextWrap="true"
        :textWrapSettings="wrapSettings"
        :excelQueryCellInfo="excelQueryCellInfo"
        :allowExcelExport="true"
        :sortSettings="sortOptions"
        :rowDataBound="rowInvoiceDataBound"
        :queryCellInfo="queryCellInfo"
      >
        <e-columns>
          <e-column
            headerText="Edit Transaction"
            :commands="commands3"
            textAlign="center"
            width="140"
          />
          <!-- header text is used to indicated invoice status, if changing update accordingly -->
          <e-column field="invoiceNumber" headerText="Invoice #" textAlign="Left" width="140" />
          <e-column
            field="invoiceDate"
            headerText="Invoice Date"
            textAlign="center"
            width="140"
            type="date"
            :format="gridDateFormat"
          />
          <e-column
            field="totalAmount"
            headerText="Invoice Amount"
            textAlign="center"
            width="140"
            format="C2"
          />
          <e-column
            field="totalLevy"
            headerText="Levy Amount"
            textAlign="center"
            width="140"
            format="C2"
          />
          <e-column
            field="invoiceAmount"
            headerText="Total Invoice"
            textAlign="center"
            width="140"
            format="C2"
          />
          <e-column
            field="refundAmount"
            headerText="Refund Amount"
            textAlign="center"
            width="140"
            format="C2"
          />
          <e-column field="invoiceStatus" headerText="Invoice Status" width="140" />
           <e-column
            field="requestType"
            headerText="Application Type"
            textAlign="Left"
            width="240"
            clipMode="EllipsisWithTooltip"
          />
          <e-column
            field="internalNotes"
            headerText="Internal Comments"
            textAlign="Left"
            width="150"
            clipMode="EllipsisWithTooltip"
          />
          <e-column
            field="requestor"
            headerText="Applicant Name"
            textAlign="Left"
            width="160"
            clipMode="EllipsisWithTooltip"
          />
            <e-column
            field="requestUserEmail"
            headerText="Applicant Email"
            textAlign="Left"
            width="200"
            clipMode="EllipsisWithTooltip"
          />
          <e-column
            field="company"
            headerText="Applicant Company"
            textAlign="Left"
            width="200"
            clipMode="EllipsisWithTooltip"
          />
          <e-column field="siteOwner" headerText="Site Owner" textAlign="Left" width="200" />
          <e-column
            field="siteId"
            headerText="Site Number"
            textAlign="Left"
            width="200"
            clipMode="EllipsisWithTooltip"
            />
          <e-column
            field="siteAddress"
            headerText="Site Address"
            textAlign="Left"
            width="300"
            clipMode="EllipsisWithTooltip"
            />
          <e-column
            field="paymentMethod"
            headerText="Payment Method"
            textAlign="Left"
            width="160"
          />
          <e-column field="paymentType" headerText="Payment Type" textAlign="Left" width="140" />
          <e-column field="referencePO" headerText="Reference/PO #" textAlign="Left" width="160" />
          <e-column
            field="transactionNumber"
            headerText="Transaction #"
            textAlign="Left"
            width="180"
          />
          <e-column
            type="date"
            :format="gridDateFormat"
            field="transactionUpdateDate"
            headerText="Transaction Date"
            textAlign="Left"
            width="140"
          />
          <e-column
            field="transactionUpdateUser"
            headerText="Transaction Update User"
            textAlign="Left"
            width="180"
            clipMode="EllipsisWithTooltip"
          />
          <e-column
            type="date"
            field="cancelledRefundMetDate"
            headerText="Cancel/Refund/WO Date"
            textAlign="Left"
            :format="gridDateFormat"
            width="180"
          />
        <e-column
          field="cancelledRefundReason"
          headerText="Cancel/Refund/WO Reason"
          textAlign="Left"
          width="180"
          clipMode="EllipsisWithTooltip"
        />
        <e-column
          field="cancelledRefundMetBy"
          headerText="Cancel/Refund/WO by User"
          textAlign="Left"
          width="180"
          clipMode="EllipsisWithTooltip"
        />
        <e-column
          type="date"
          :format="gridDateFormat"
          field="lastUpdatedDate"
          headerText="Date of Update"
          textAlign="Left"
          width="160"
        />
          <e-column headerText="Invoice" :commands="commands" textAlign="center" width="120" />
          <e-column headerText="Receipt" :commands="commands2" textAlign="center" width="120" />
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
  ExcelExport,
} from '@syncfusion/ej2-vue-grids';
import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
import { tokenStorage } from '@/shared/storage-service';
import { mapGetters } from 'vuex';
import { reportExportFileName } from '@/utils/report-utils';
import { getInvoicePDF, getReceiptPDF } from '../services/accounting-api';
// import { getReceiptPDF } from '../services/receipt-api';
// eslint-disable-next-line import/extensions
import { getDataGridDateFormat, getExcelReportDate } from '../../../utils/date-utils.js';
import { SET_PREVIOUS_ACCOUNTING_TAB } from '../store';

Vue.use(GridPlugin);
Vue.use(TabPlugin);

export default {
  name: 'AccountingClosedInvoice',
  props: {
    isValidUser: Boolean,
  },
  data() {
    return {
      actionableColumnHeaders: { invoiceNumber: 'Invoice #' },
      invoiceStatuses: {
        cancelled: 'Cancelled', paid: 'Paid', refund: 'Paid (Refund)', wo: 'Cancelled-WO',
      },
      headerText0: { text: 'Open Invoices' },
      headerText1: { text: 'Closed Invoices' },
      headerText2: { text: 'Historical Invoices' },
      headerText3: { text: 'Refunds' },
      headerText4: { text: 'Credits' },
      content0: '#ClosedInvoicesTab',
      sortOptions: { columns: [{ field: 'transactionUpdateDate', direction: 'Descending' }] },
      content1: '#OtherTab',
      commands: [
        {
          type: 'View Invoice',
          buttonOption: {
            cssClass: 'e-flat viewpdfbtn',
            iconCss: 'e-export-pdf e-icons',
          },
        },
      ],
      commands2: [
        {
          type: 'View Receipt',
          buttonOption: {
            cssClass: 'e-flat viewpdfbtn',
            iconCss: 'e-export-pdf e-icons',
          },
        },
      ],
      commands3: [
        {
          type: 'Edit',
          buttonOption: { cssClass: 'e-flat', iconCss: 'e-edit e-icons' },
        },
      ],
      toolbarOptions: ['Search', 'ExcelExport'],
      pageSettings: { pageSize: 10 },
      target: '#target',
      wrapSettings: { wrapMode: 'Header' },
      gridDateFormat: getDataGridDateFormat(),
    };
  },
  computed: {
    ...mapGetters({
      accountingClosedInvoices: 'accountingClosedInvoices',
      loggedUser: 'loggedUser',
    }),
    loggedUserId() {
      return this.loggedUser?.id;
    },
  },
  methods: {
    created() {
      // Added clear button and its functionalities to Searchbar
      if (this.$refs.refAccountingClosedInvoicesGrid) {
        document
          .getElementById(`${this.$refs.refAccountingClosedInvoicesGrid.$el.id}_searchbar`)
          .addEventListener('keyup', (e) => {
            this.clearSearchEventListener(e, this.$refs.refAccountingClosedInvoicesGrid.$el.id);
          });
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove('e-search-icon');
      clearBtnEle.classList.add('e-clear-icon');

      clearBtnEle.addEventListener('click', () => {
        e.target.value = '';
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value === '') {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    async cmdClosedInvoiceClick(args) {
      const invoice = args.rowData;
      const { invoiceId, orderNumber } = invoice;
      // eslint-disable-next-line default-case
      const accessToken = tokenStorage.getAccessToken();
      // eslint-disable-next-line default-case
      switch (args.commandColumn.type) {
        case 'View Invoice':
          // eslint-disable-next-line no-case-declarations
          await getInvoicePDF(accessToken, this.loggedUserId, invoiceId).then((res) => {
            window.location.href = `${res.config.baseURL}${res.config.url}`;
          });
          break;
        case 'View Receipt':
          // eslint-disable-next-line no-case-declarations
          if (orderNumber !== null && orderNumber !== undefined && orderNumber !== '') {
            await getReceiptPDF(accessToken, this.loggedUserId, orderNumber, invoiceId).then(
              (res) => {
                window.location.href = `${res.config.baseURL}${res.config.url}`;
              },
            );
          }
          break;
        case 'Edit':
          this.$store.commit(SET_PREVIOUS_ACCOUNTING_TAB, { previousTab: 1 });
          this.$router.push(`/accounting/transactionEdit/${args.rowData.invoiceId}`);
          break;
      }
    },
    excelQueryCellInfo(args) {
      // eslint-disable-next-line default-case
      switch (args.column.field) {
        case 'invoiceDate':
          // eslint-disable-next-line no-param-reassign
          args.value = getExcelReportDate(args.value);
          break;
        case 'paymentDate':
          // eslint-disable-next-line no-param-reassign
          args.value = getExcelReportDate(args.value);
          break;
        case 'lastUpdatedDate':
          // eslint-disable-next-line no-param-reassign
          args.value = getExcelReportDate(args.value);
          break;
        case 'cancelledRefundMetDate':
          // eslint-disable-next-line no-param-reassign
          args.value = getExcelReportDate(args.value);
          break;
        case 'transactionUpdateDate':
          // eslint-disable-next-line no-param-reassign
          args.value = getExcelReportDate(args.value);
          break;
      }
    },
    toolbarClick(args) {
      // eslint-disable-next-line default-case
      switch (args.item.text) {
        case 'Excel Export':
          this.$refs.refAccountingClosedInvoicesGrid.excelExport({
            fileName: reportExportFileName('Closed Invoices.xlsx'),
          });
          break;
      }
    },
    queryCellInfo(args) {
      this.colorCodeInvoiceNumberByStatus(
        args.column?.headerText,
        args.cell,
        args.data,
      );
    },
    colorCodeInvoiceNumberByStatus(colHeader, cell, invoice) {
      if (colHeader === this.actionableColumnHeaders.invoiceNumber) {
        if (invoice.invoiceStatus === this.invoiceStatuses.cancelled
        || invoice.invoiceStatus === this.invoiceStatuses.wo) {
          // eslint-disable-next-line no-param-reassign
          cell.className += ' status-cancel';
        } else if (invoice.invoiceStatus === this.invoiceStatuses.refund) {
          // eslint-disable-next-line no-param-reassign
          cell.className += ' status-refund';
        } else if (invoice.invoiceStatus === this.invoiceStatuses.paid) {
          // eslint-disable-next-line no-param-reassign
          cell.className += ' status-paid';
        }
      }
    },
    rowInvoiceDataBound(args) {
      if (args.data.userPaymentType === 'Credit Card'
       || args.data.invoiceStatus !== this.invoiceStatuses.paid) {
        // eslint-disable-next-line no-param-reassign
        args.row
          .querySelectorAll('.e-unboundcelldiv')[0]
          .querySelectorAll('button')[0].style.display = 'none';
      }
      if (args.data.invoiceStatus === 'Cancelled-WO'
         || args.data.invoiceStatus === 'Cancelled') {
        // eslint-disable-next-line no-param-reassign
        args.row
          .querySelectorAll('.e-unboundcelldiv')[2]
          .querySelectorAll('button')[0].style.display = 'none';
      }
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search, ExcelExport],
  },
};
</script>

<style>

.status-cancel {
   color: rgb(128, 127, 126) !important;
}
td.status-cancel::before,td.status-paid::before,td.status-refund::before {
    content: "..";
    margin-right: 10px;
    color: transparent;
}
td.status-refund::before {
    background: #ff5e00;
}
td.status-paid::before {
    background: rgb(4, 206, 4);
}
td.status-cancel::before {
  background: gray;
}
</style>
